import React from "react";
import { Facebook } from "lucide-react";
import { CIMA } from "@/lib/cima";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-[var(--cima-navy)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="bg-white inline-block p-3">
              <img
                src={CIMA.logoUrl}
                alt="CIMA"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="mt-5 text-white/70 max-w-md text-sm leading-relaxed">
              Comercializadora Industrial Médica — Distribución segura y confiable de gases
              industriales, medicinales y equipos especializados en Zihuatanejo, Gro.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={CIMA.facebookUrl}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-facebook-link"
                aria-label="Síguenos en Facebook"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#1877F2] transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-semibold text-white mb-4">Navegación</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#sobre" className="hover:text-[var(--cima-orange-soft)]">Sobre Nosotros</a></li>
              <li><a href="#servicios" className="hover:text-[var(--cima-orange-soft)]">Servicios</a></li>
              <li><a href="#productos" className="hover:text-[var(--cima-orange-soft)]">Productos</a></li>
              <li><a href="#seguridad" className="hover:text-[var(--cima-orange-soft)]">Seguridad</a></li>
              <li><a href="#contacto" className="hover:text-[var(--cima-orange-soft)]">Contacto</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-semibold text-white mb-4">Contáctanos</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href={`tel:${CIMA.phoneTel}`} className="hover:text-[var(--cima-orange-soft)]">Tel: {CIMA.phone}</a></li>
              <li>WhatsApp: {CIMA.whatsapp}</li>
              <li className="break-all">{CIMA.email}</li>
              <li>{CIMA.address}</li>
              <li>{CIMA.hoursFull}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 justify-between text-xs text-white/50">
          <div>© {year} CIMA · Comercializadora Industrial Médica. Todos los derechos reservados.</div>
          <div className="font-mono-cima uppercase tracking-widest">Zihuatanejo · Guerrero · México</div>
        </div>
      </div>
    </footer>
  );
}
